module.exports = __webpack_public_path__ + "img/partner-pat.2deb720e.png";